module.exports = "<div class=\"flex-grow\" (window:resize)=\"onResize($event)\">\n    <div id=\"gameContainer\"></div>\n    <app-loading [progress]=\"progress\" [hidden]=\"!isLoading\"></app-loading>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/unity/unity.component.html
// module id = ./src/app/unity/unity.component.html
// module chunks = main